import styled from 'styled-components';

const AuthContainer = styled.div`
  display: flex;
  overflow: hidden;
`;

export { AuthContainer };
